import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-funds-dialog',
  templateUrl: './funds-dialog.component.html',
  styleUrls: ['./funds-dialog.component.scss']
})
export class FundsDialogComponent {
  @Input() funds;
  @Output() allSelectedFunds = new EventEmitter<any>();
  selectedFunds: any  = [];
  constructor() { }

  isAllSelected(){
    if (Array.isArray(this.funds)) {
      return this.funds.every(fund => fund.selected)
    }
    return false;
  } 
  toggleSelectAll(event){
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
        this.selectedFunds = [];
        this.funds.forEach(fund => {
            fund.selected = true; 
            this.selectedFunds.push(fund);
        });
    } else {
        this.funds.forEach(fund => {
            fund.selected = false;
        });
        this.selectedFunds = [];
    }
    this.allSelectedFunds.emit(this.selectedFunds)
  }
  onCheckboxChange(fund){
    if (fund.selected) {
      this.selectedFunds.push(fund);
    } else {
      this.selectedFunds = this.selectedFunds.filter(selected => selected !== fund);
    }
    this.allSelectedFunds.emit(this.selectedFunds)
  }

}
